module.exports = __webpack_public_path__ + "static/NewJune-light-3ebe9fc963183f96c38c6492ca5a7a3f.woff2";